// Brand constants for Frog Knows Natives
export const BRAND = {
  APP_NAME: "Frog Knows Natives",
  APP_TAGLINE: "The Frog Knows What Grows",
  MASCOT_NAME: "Hopper",
  
  // Tier names
  TIER_FREE: "Free Explorer",
  TIER_CORE: "Quick Plan",
  TIER_PLUS: "Full Plan",
  
  // SEO
  META_TITLE: "Frog Knows Natives | Native Plant Plans for Your Yard",
  META_DESCRIPTION: "Frog Knows Natives helps homeowners build native gardens with confidence using friendly guidance based on their yard conditions.",
  
  // OpenGraph
  OG_TITLE: "Frog Knows Natives",
  OG_IMAGE: "/og-native-plant-garden-planner.png",
  
  // Legal
  COPYRIGHT: `© ${new Date().getFullYear()} Frog Knows Natives. All rights reserved.`,
  DISCLAIMER: "Frog Knows Natives is an educational planning tool. Plant recommendations are based on general regional data and should be verified for local conditions before installation. This is not professional landscaping, environmental, or legal advice. No guarantees of plant survival or outcomes.",
  DISCLAIMER_SHORT: "Frog Knows Natives is an educational planning tool. Plant recommendations are based on general regional data and should be verified for local conditions before installation.",
} as const;
